import { render, staticRenderFns } from "./ManageAccessories.vue?vue&type=template&id=0dfeb222"
import script from "./ManageAccessories.vue?vue&type=script&lang=js"
export * from "./ManageAccessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports